module.exports = __webpack_public_path__ + "static/media/Icon-phone-orange.6d839858.svg";